import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useStatsigClient } from '@statsig/react-bindings';

import type { SurveyListItem } from '@api/surveys/utilities/types';
import { GATES } from '@constants';
import { IconCTA, OverlayTriggerTooltip, RepromptIcon } from '@utilities';

import ResumeModal from './components/ResumeModal';

interface ResumeProps {
  isHoverAction?: boolean;
  onSubmit: ({ refreshItems }: { refreshItems: boolean }) => void;
  selectedRows: Array<SurveyListItem>;
}

const Resume = ({ isHoverAction, onSubmit, selectedRows = [] }: ResumeProps) => {
  const { permissions = {} } = useSelector((state: any) => state?.user?.data);
  const [isActive, setIsActive] = useState(false);

  const { client } = useStatsigClient();
  const useCalypsoProvider = client.checkGate(GATES.USE_CALYPSO_AS_SURVEY_PROVIDER);

  const handleSubmit = () => {
    setIsActive(false);
    onSubmit({ refreshItems: true });
  };

  const hasSurveyRef = Boolean(selectedRows[0]?.atlasInstantSurveyRef);
  const isSingleSelect = selectedRows.length === 1;
  const isPaused = selectedRows[0]?.isPaused;
  const isVisible =
    hasSurveyRef &&
    isSingleSelect &&
    isPaused &&
    permissions.canAdvancedEditSurvey &&
    useCalypsoProvider;

  if (!isVisible) return null;

  return (
    <>
      <OverlayTriggerTooltip content={isHoverAction ? 'Resume' : ''}>
        <IconCTA
          data-testid="resume-cta"
          icon={<RepromptIcon />}
          onClick={() => setIsActive(true)}
          text={isHoverAction ? '' : 'Resume'}
        />
      </OverlayTriggerTooltip>
      {isActive && (
        <ResumeModal
          id={selectedRows[0].id}
          onClose={() => setIsActive(false)}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
};

export default Resume;
